export default "__VITE_ASSET__BYs66rq7__"